import lodash from 'lodash';

import { useEffect, useRef, useState } from 'react';

import './Slider.scss';

export default function Slider({ min, max, value, step = 1, handler, onMouseDown, onTouchEnd, thresholdColor, disabled = false, isListeners = false }) {

  const input = useRef();
  const [val, setVal] = useState(value);

  useEffect(() => {
    handler?.(val);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [val]);

  const percent = lodash.clamp(100 * (value - min) / (max - min), 0, 100);

  let sliderStyle;
  if (isListeners) {
    sliderStyle = {
      background: `
        linear-gradient(90deg, #5d5d5d 0%, #343434 100%),
        linear-gradient(90deg, #686868 60.1%, #3a3a3a 100%),
        linear-gradient(to right, transparent ${percent}%, #E9E9EB ${percent}%)
      `,
      backgroundBlendMode: "overlay",
      boxShadow: "inset 1px 4px 7px 0 rgba(0, 0, 0, 0.28)",
    };
  } else {
    sliderStyle = {
      "--slider-color": thresholdColor,
      background: `linear-gradient(to right, ${thresholdColor} ${percent}%, #E9E9EB ${percent}%)`,
    };
  }

  return (
    <input
      ref={input}
      className={`slider ${isListeners ? 'slider--listeners' : ''}`}
      disabled={disabled}
      style={sliderStyle}
      type='range'
      min={min}
      max={max}
      step={step}
      value={value}
      onInput={() => { setVal(input.current.value) }}
      onMouseDown={() => { input.defaultValue = value; onMouseDown(); }}
      onTouchEnd={() => { input.defaultValue = value; onTouchEnd(); }}
    />
  );
}
